<template>
    <emoji-picker>
        <div class="absolute pin-t pin-r cursor-pointer emoji-invoker outline-none" slot="emoji-invoker" slot-scope="{ events: { click: clickEvent } }" @click.stop="clickEvent">
            <button class="outline-none h-6 w-6 rounded-full opacity-25 hover:opacity-75">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current text-grey">
                    <path d="M0 0h24v24H0z" fill="none"/>
                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"/>
                </svg>
            </button>
        </div>
        <div slot="emoji-picker" slot-scope="{ emojis }">
            <div class="absolute z-10 border w-64 h-96 overflow-scroll p-4 rounded bg-white shadow t-4 -r-64">
                <div>
                    <div v-for="(emojiGroup, category) in emojis" :key="category">
                        <h5 class="text-grey-darker uppercase text-sm cursor-default mb-2 mt-4">{{ category }}</h5>
                        <div class="flex flex-wrap justify-between emojis">
                            <button
                            class="p-1 cursor-pointer rounded hover:bg-grey-light focus:outline-none focus:shadow-outline flex items-center justify-center h-6 w-6"
                            v-for="(emoji, emojiName) in emojiGroup"
                            :key="emojiName"
                            @click="$emit('emoji-added', emoji)"
                            :title="emojiName"
                            >{{ emoji }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </emoji-picker>
</template>

<script>
    import EmojiPicker from 'vue-emoji-picker';
    export default {
        components: {
            EmojiPicker
        }
    }
</script>
